import { ActionTree, Commit, Dispatch } from "vuex";
import types from "@/store/types";

import { RootState } from "@/store/state";

export const actions: ActionTree<RootState, any> = {
    [types.actions.SETUP]: async ({ dispatch, commit }: { dispatch: Dispatch; commit: Commit }): Promise<void> => {
        if (window.navigator.onLine) {
            dispatch(types.actions.CONNECTED);
        }
        window.addEventListener("online", () => {
            dispatch(types.actions.CONNECTED);
        });
        window.addEventListener("offline", () => {
            dispatch(types.actions.DISCONNECTED);
        });
    },
    [types.actions.CONNECTED]: async ({ commit, state }: { commit: Commit; state: RootState }) => {
        console.info("online");
        commit(types.mutations.SET_LAST_CONNECTED_TIME, undefined);
        commit(types.mutations.SET_IS_ONLINE, true);
    },
    [types.actions.DISCONNECTED]: async ({ commit }: { commit: Commit }) => {
        console.error("offline");
        commit(types.mutations.SET_LAST_CONNECTED_TIME, new Date().valueOf() / 1000);
        commit(types.mutations.SET_IS_ONLINE, false);
    },
};
